import { combineEpics } from "redux-observable";
import { epicWaterTowerCollectWater } from "./epics/epicWaterTowerCollectWater";
import { epicWaterTowerSelect } from "./epics/epicWaterTowerSelect";
export var epicWaterTower = combineEpics(epicWaterTowerCollectWater, epicWaterTowerSelect);



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/epicWaterTower.ts
// module id = 2504
// module chunks = 3